/**
 * Split Slideshow for Shopify
 * File: assets/split-slideshow.js
 */

document.addEventListener('DOMContentLoaded', function() {
  
  const containers = document.querySelectorAll('.split-slideshow-container');
  
  containers.forEach(container => {
    const swiperEl = container.querySelector('.main-swiper');
    if (!swiperEl) return;
    
    // Simple Swiper setup
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      speed: 400,
      on: {
        slideChange: function() {
          updateMobile(container, this.realIndex);
        }
      }
    });
    
    // Update mobile content
    function updateMobile(container, index) {
      // Hide all mobile content
      const contents = container.querySelectorAll('.mobile-content-item');
      contents.forEach(content => content.style.display = 'none');
      
      // Show current content
      if (contents[index]) {
        contents[index].style.display = 'block';
      }
      
      // Update dots
      const dots = container.querySelectorAll('.mobile-dot');
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    // Mobile dots click
    const dots = container.querySelectorAll('.mobile-dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        swiper.slideTo(index);
      });
    });
    
    // Arrows
    const prevBtn = container.querySelector('.slider-nav-arrow.prev');
    const nextBtn = container.querySelector('.slider-nav-arrow.next');
    
    if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev());
    if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext());
    
    // Initialize mobile
    updateMobile(container, 0);
  });
  
});